





import Vue from 'vue';
import Navigation from '@/components/Navigation/Navigation.vue';

export default Vue.extend({
    name: 'NavigationViewing',
    components: {
        Navigation,
    },
    data() {
        return {
            menuItems: [
                {
                    to: '/tables',
                    title: 'Таблицы',
                    description: 'Таблицы значений показателей',
                    componentName: 'b-icon-card-list',
                },
                {
                    to: '/graphs',
                    title: 'Графики',
                    description: 'Графики значений показателей',
                    componentName: 'b-icon-graph-up',
                },
                {
                    to: '/excel',
                    title: 'Экспорт в Excel',
                    description: 'Экспорт значений показателей в Excel',
                    componentName: 'b-icon-table',
                },
                {
                    to: '/about',
                    title: 'О программе',
                    description: 'Информация о программе',
                    componentName: 'b-icon-info-circle',
                },
            ],
            caption: 'Просмотр значений показателей',
        };
    },
    metaInfo: {
        title: 'Просмотр',
    },
});
